import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { bridgewaterConfig } from "./data";

export default function BridgewaterPage() {
  return <CityPageTemplate config={bridgewaterConfig} />;
}